
import ErrorHandler from '@js/ErrorHandler';

let sessionStorageSupported = true;

export default {
	getItem(key) {
		if (!sessionStorageSupported) return null;

		try {
			return sessionStorage.getItem(key);
		} catch(error) {
			sessionStorageSupported = false;
			ErrorHandler.reportError(`Failed to get ${key} from sessionStorage!`, error);
			return null;
		}
	},

	setItem(key, value) {
		if (!sessionStorageSupported) return null;

		try {
			return sessionStorage.setItem(key, value);
		} catch(error) {
			sessionStorageSupported = false;
			ErrorHandler.reportError(`Failed to set ${key} to sessionStorage!`, error);
			return null;
		}
	}
};
